import {Dict} from "../../Core/Reflection";
import {ItemType} from "../../Data/ItemModel";

export interface AssemblyModel<T extends string> {
    readonly assemblyType: AssemblyType;
    readonly slots: Dict<T, number>;
    readonly render?: string;
}

export enum AssemblyType {
    Robot = ItemType.Robot,
    Monster = ItemType.Monster,
    Movie = ItemType.Movie,
}